import { Component } from '@angular/core';

@Component({
  selector: 'app-ninja-banner',
  standalone: true,
  template: `
    <span class="side-panel-label">Sponsored</span>
    <a href="https://ninjatraderdomesticvendor.sjv.io/c/6921402/3254386/37581"
       rel="sponsored" target="_blank">
      <img
        src="/assets/images/NT_180x180.jpg"
        srcset="/assets/images/NT_180x180.jpg 1x, /assets/images/NT_360x360.jpg 2x"
        width="180"
        height="180"
        decoding="async"
        loading="eager"
        fetchpriority="high"
        alt="NinjaTrader"
      />
    </a>
  `
})
export class NinjaBannerComponent {}

